import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService} from '../../shared/services/index';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';


@Component({
    selector: 'app-model-group-characteristics',
    templateUrl: './model-group-characteristics.component.html',
    styleUrls: ['./model-group-characteristics.component.scss'],
    standalone: false
})
export class ModelGroupCharacteristicsComponent extends BaseAccordionComponent implements OnInit {
  @Input() showLegacy: boolean = false;

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {
    super(fb, storage);
  }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      reusableSurgical: ['', { validators: [] }],
      measuringFunction: ['', { validators: [] }],
      activePowered: ['', { validators: [] }],
      implantable: ['', { validators: [] }],
      administeringMedicine: ['', { validators: [] }],
      containsMedicinalProductSubstance: ['', { validators: [] }],
      containingAnimalTissues: ['', { validators: [] }],
      containingHumanTissues: ['', { validators: [] }],
      forRiskClassImplantable: ['', { validators: [] }],
      containsBloodOrPlasmaSubstance: ['', { validators: [] }],
      medPurposeForm: this.fb.array([this.addMedPurposeForm()]),
      containsMicrobialSubstances: ['', { validators: [] }],
      companionDiagnostic: ['', { validators: [] }],
      nearPatientTesting: ['', { validators: [] }],
      patientSelfTesting: ['', { validators: [] }],
      reagent: ['', { validators: [] }],
      professionalTesting: ['', { validators: [] }],
      instrument: ['', { validators: [] }],
      ivdKit: ['', { validators: [] }]
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
    });
  }

  get medPurposeForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('medPurposeForm');
  }

  addMedPurposeForm(): FormGroup {

    return this.fb.group({
      value: ['', { validators: [] }],
      language: ['', { validators: [] }]
    });
  }

  setMedPurposeForm(): FormArray {

    const formArray = new FormArray([]);

    let item: any;

    item = this.displayItemData('Medical Purpose of System or Procedure Pack?');

    if (item && item.length > 0) {
      item.forEach((c, i) => {
        formArray.push(

          this.fb.group({
            value: c[(this.getMapInnerPathName('Med Purpose Value'))[0]],
            language: c[(this.getMapInnerPathName('Med Purpose Language'))[0]]
          })
        );
      });
    }

    return formArray;
  }


  patchForms() {

    this.deviceForm.patchValue({

      reusableSurgical: this.displayItemData('Reusable Surgical Instrument?'),
      measuringFunction: this.displayItemData('Measuring Function?'),
      implantable: this.displayItemData('Implantable?'),
      administeringMedicine: this.displayItemData('Administer or Remove a Medicinal Substance?'),
      activePowered: this.displayItemData('Active Device?'),
      containsMedicinalProductSubstance: this.displayItemData('Presence of a Medicinal Product Substance?'),
      containsBloodOrPlasmaSubstance: this.displayItemData('Presence of a Medicinal Product Substance Derived from Human Blood or Plasma?'),
      containingAnimalTissues: this.displayItemData('Presence of Animal Tissues, Cells, or Derivatives?'),
      containingHumanTissues: this.displayItemData('Presence of Human Tissues, Cells, or Derivatives?'),
      forRiskClassImplantable: this.displayItemData('For Risk Class IIb implantable?'),
      containsMicrobialSubstances: this.displayItemData('Presence of Cells or Substances of Microbial Origin?'),
      companionDiagnostic: this.displayItemData('Companion Diagnostic?'),
      nearPatientTesting: this.displayItemData('Near Patient Testing?'),
      patientSelfTesting: this.displayItemData('Patient Self Testing?'),
      reagent: this.displayItemData('Reagent?'),
      professionalTesting: this.displayItemData('Professional Testing?'),
      instrument: this.displayItemData('Instrument?'),
      ivdKit: this.displayItemData('IVD Kit?')
    });

    this.deviceForm.setControl('medPurposeForm', this.setMedPurposeForm());
  }

  showRiskClassImplantable(): boolean {
    const applicableRegulationStr = this.resolveApplicableRegulationForCurrentDataScope(this.itemData?.modelData);

    if (!applicableRegulationStr) {
      return false;
    }

    const legacyTypes = ['MDD', 'AIMDD', 'IVDD', 'MDD-AIMDD'];

    return legacyTypes.includes(applicableRegulationStr);
  }
}
